import UrlParse from 'url-parse';

export const changeHistory = (queryName: string, queryValue?: string | number) => {
    const urlParse = UrlParse(window.location.href, true);

    let query;

    if (queryValue) {
        query = {
            ...urlParse.query,
            [queryName]: queryValue,
        };
    } else {
        delete urlParse.query[queryName];

        // Объявленная переменная с присваиванием, линтер не выйдет пофиксить
        // eslint-disable-next-line prefer-destructuring
        query = urlParse.query;
    }

    const { href, origin } = urlParse.set('query', query);

    const path = href.replace(origin, '');

    // Непонятны назначение и работоспособность второго аргумента https://github.com/whatwg/html/issues/2174
    window.history.replaceState(null, '', path);
};
